import { IAstNode } from '../typings/ast-node';
import { TokenComposeError } from '../errors';

export function getAstNodePositions(astNode: IAstNode) {
  if (astNode.type === 'Atom') {
    return [astNode.token.position];
  }

  if (astNode.type === 'IdentifierArray') {
    return [
      astNode.openBracketToken.position,
      astNode.closeBracketToken.position
    ];
  }

  // if (astNode.type === 'FunctionCall') { }
  // if (astNode.type === 'LogicNot') { }
  // if (astNode.type === 'Arithmetic') { }
  // if (astNode.type === 'Comparison') { }
  // if (astNode.type === 'Arithmetic') { }
}


/**
 * 将Token按逗号分隔，主要是针对 函数参数 和 字面量数组
 * @param astNodes Token 集合
 */
export function splitTokensWithComma(astNodes: IAstNode[]) {
  const args: IAstNode[][] = [];
  let i = 0;
  let bracketCount = 0;
  let parenthesisCount = 0;
  while (i < astNodes.length) {
    const { token } = astNodes[i++];

    if (token!.type === 'Comma') {
      if (bracketCount === 0 && parenthesisCount === 0) {
        args.push(astNodes.splice(0, i - 1));
        astNodes.shift();
        i = 0;
      }
      // 防止出现`SUM(1,2,)`参数最后为逗号的情况
      if (!astNodes.length) {
        args.push([]);
      }
      continue;
    }

    if (token!.type === 'OpenParenthesis') {
      parenthesisCount++;
    } else if (token!.type === 'CloseParenthesis') {
      parenthesisCount--;
    }

    if (token!.type === 'OpenBracket') {
      bracketCount++;
    } else if (token!.type === 'CloseBracket') {
      bracketCount--;
    }

    if (i === astNodes.length) {
      if (bracketCount !== 0 || parenthesisCount !== 0) {
        throw new TokenComposeError('function-arguments-error', '无效的函数参数', token!.position);
      }
      args.push(astNodes);
    }

  }


  return args;
}
